<template>
  <div class="box">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <!-- <el-form-item label="发布时间">
        <el-date-picker
          v-model="formInline.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions1"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="岗位名称">
        <el-input placeholder="请输入岗位名称" v-model="formInline.e_name"></el-input>
      </el-form-item>-->
      <el-form-item>
        <!-- <el-button type="primary" @click="onSubmit">查询</el-button> -->
        <el-button type="primary" @click="add()">发布平台岗位</el-button>
        <span class="info">该岗位发布方式，由平台直接推送至习讯云APP、小程序及企校云平台，平台应往届上百万学生可查看投递，付费后排名更靠前，简历投递量更大！</span>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" id="table">
      <el-table-column fixed prop="created_at" label="发布时间" min-width="140px" align="center"></el-table-column>
      <el-table-column prop="job_name" label="岗位名称"></el-table-column>

      <!-- <el-table-column label="总投递" prop="apply_count"></el-table-column> -->
      <el-table-column prop="recruitment" label="招聘人数"></el-table-column>
      <el-table-column prop="salary" label="岗位待遇"></el-table-column>
      <el-table-column label="到期时间" min-width="100px" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.due_time">{{scope.row.due_time}}</span>
          <span v-else>该岗位还未付费</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="上线状态" formatter="publishStatus">
        <template slot-scope="scope">
          <span v-if="scope.row.status=='online'" style="color:#67C23A;">已上线</span>
          <span v-if="scope.row.status=='offline'" style="color:#E6A23C;">已下线</span>
          <el-tooltip class="item" effect="dark" content="联系管理员快速审核" placement="top">
            <span v-if="scope.row.status=='no_audit'" style="color:#F56C6C; font-weight:bold">待审核</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="pay_status" label="付费状态">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.pay_status=='no_paid'" style="color:#F56C6C;">待发布</span>
          <span
            v-if=" (scope.row.pay_status=='paid' || !scope.row.pay_status || scope.row.pay_status=='valid') && scope.row.status=='online'"
            style="color:#67C23A;"
          >已上线</span>
          <span
            v-if=" (scope.row.pay_status=='paid' || !scope.row.pay_status || scope.row.pay_status=='valid') && scope.row.status=='offline'"
            style="color:#E6A23C;"
          >已下线</span>-->
          <span v-if="scope.row.pay_status=='no_paid'" style="color:#F56C6C;">未付费</span>
          <span v-if="scope.row.pay_status=='paid'" style="color:#67C23A;">已付费</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" min-width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="read(scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="update(scope.row)">编辑</el-button>

          <el-button
            size="mini"
            type="info"
            @click="offline(scope.row.id)"
            v-if="scope.row.status=='online'"
          >下线</el-button>
          <!-- v-if="scope.row.status=='online'  && (scope.row.pay_status=='paid' || !scope.row.pay_status || scope.row.pay_status=='valid')" -->
          <el-button
            size="mini"
            type="success"
            @click="valid(scope.row.id)"
            v-if="scope.row.status=='offline'"
          >上线</el-button>
          <!-- v-if="scope.row.status=='offline' && (scope.row.pay_status=='paid' || !scope.row.pay_status || scope.row.pay_status=='valid')" -->
          <!-- <el-tooltip class="item" effect="dark" content="招募后学生可见" placement="top">
            <el-button
              size="mini"
              type="warning"
              @click="toPay(scope.row.id)"
              v-if="scope.row.pay_status=='no_paid'"
            >开始招募</el-button>
          </el-tooltip> -->

          <!-- <el-tooltip class="item" effect="dark" content="" placement="top"> -->
          <!-- <el-button
            size="mini"
            type="success"
            v-if="scope.row.status=='no_audit'"
          >待审核</el-button>-->
          <!-- </el-tooltip> -->

          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row)"
            v-if="scope.row.status=='offline' || scope.row.pay_status=='no_paid'"
          >删除</el-button>

          <!-- <el-button size="mini" type="success" v-else>已付费</el-button> -->
          <!-- <el-button size="mini" type="primary" @click="del(scope.row)">删除</el-button> -->
        </template>
        <!-- 查看弹窗框 -->
        <el-dialog :visible.sync="dialogVisible" width="500px" :append-to-body="true">
          <el-row v-for="item in dialog" :key="item.key">
            <el-col :span="6">
              <div style="text-align: right;">{{ item.name }}</div>
            </el-col>
            <el-col :span="12">
              <div>{{ item.value }}</div>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="6" style="text-align: right;">发布渠道：</el-col>
            <el-col :span="18">{{channel}}</el-col>
          </el-row>-->
        </el-dialog>
      </el-table-column>
    </el-table>
    <Pagination
      ref="pagination"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <!-- 选择发布时长弹出框 -->
    <el-dialog title="请进行岗位发布认证" :visible.sync="dialogFormVisible" width="500px">
      <div class="infoText">当前岗位发布需认证付费，请选择您要发布的岗位有效月份数，并完成付费认证，即可开启招聘！付费后您的岗位排名TOP10%！</div>
      <el-form>
        <el-radio v-model="monthRadio" :label="payInfo[0].code">{{payInfo[0].value}}元/1个月</el-radio>
        <el-radio v-model="monthRadio" :label="payInfo[1].code">{{payInfo[1].value}}元/2个月</el-radio>
        <el-radio v-model="monthRadio" :label="payInfo[2].code">{{payInfo[2].value}}元/3个月</el-radio>
      </el-form>
      <div class="red">平台建议：岗位有效期越久排名越靠前，平台投递人数会更多</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="chooseMonth()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseUrl.js";
import qs from "qs";
import formatter from "@/assets/js/mixins/formatter";
import Pagination from "@/components/pagination"; // 分页组件

export default {
  components: {
    Pagination
  },
  data() {
    return {
      pickerOptions1: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      // formInline: {
      //   time: "",
      //   e_name: ""
      // },
      // 分页
      total: 0, // 总数
      page: 1, // 当前页
      page_size: 10, // 每页条数
      tableData: [],
      //弹出框
      dialogVisible: false,
      dialog: [
        {
          name: "发布时间：",
          key: "created_at",
          value: ""
        },
        {
          name: "岗位：",
          key: "job_name",
          value: ""
        },
        {
          name: "岗位类型：",
          key: "job_type",
          value: ""
        },
        {
          name: "学历要求：",
          key: "education",
          value: ""
        },
        {
          name: "年龄要求：",
          key: "age_require",
          value: ""
        },
        {
          name: "岗位诱惑：",
          key: "job_attraction",
          value: ""
        },
        {
          name: "截止时间：",
          key: "end_time",
          value: ""
        },
        // {
        //   name: "联系人：",
        //   key: "contact",
        //   value: ""
        // },
        // {
        //   name: "电话：",
        //   key: "telephone",
        //   value: ""
        // },
        // {
        //   name: "email：",
        //   key: "email",
        //   value: ""
        // },

        {
          name: "岗位描述：",
          key: "job_detail",
          value: ""
        },
        // {
        //   name: "岗位要求：",
        //   key: "request",
        //   value: ""
        // },
        {
          name: "招聘人数：",
          key: "recruitment",
          value: ""
        },
        {
          name: "岗位待遇：",
          key: "salary",
          value: ""
        },
        {
          name: "食宿安排：",
          key: "food_bed_str",
          value: ""
        },
        {
          name: "详细地址：",
          key: "job_address",
          value: ""
        }
        // {
        //   name: "对口专业：",
        //   key: "expect_major",
        //   value: ""
        // }
      ],
      channel: "",
      schools: "",
      dialogFormVisible: false,
      schoolList: [],
      schoolId: "",
      monthRadio: "", // 月份,
      pay_jobId: "",
      payInfo: [
        { code: 0, value: 0 },
        { code: 0, value: 0 },
        { code: 0, value: 0 }
      ]
    };
  },
  mounted() {
    this.getPayInfo();
    this.getList();
  },
  methods: {
    //获取列表
    async getList() {
      let params = {
        page: this.page,
        page_size: this.page_size
        // start: this.formInline.time[0],
        // end: this.formInline.time[1],
        // e_name: this.formInline.e_name,
        // status: "online"
      };
      let res = await this.$api.job.getPlatformJobList(params);
      if (res.code === 0) {
        if (res.data.data !== []) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
      }
    },
    // 查看岗位详情
    read(row) {
      this.dialogVisible = true;
      let dialog = this.dialog;
      for (let item of dialog) {
        item.value = row[item.key];
      }

      this.channel = "";
      if (row.type) {
        for (let item of row.type) {
          switch (item.type) {
            case "xcx":
              this.channel += "小程序，";
              break;
            case "woa":
              this.channel += "公众号，";
              break;
            case "school":
              this.channel = this.channel + item.school_name + "，";
              break;
          }
        }
      }
    },
    //查询
    onSubmit() {
      this.getList();
    },
    async getPayInfo() {
      let res = await this.$api.pay.getPlatformJobFee();
      this.payInfo = res.data;
    },
    // 发布岗位
    async add() {
      // this.dialogFormVisible = true;

      this.$router.push({
        path: "/addPlatformJob",
        query: {
          operate: "add"
        }
      });
    },

    chooseMonth() {
      this.dialogFormVisible = false;
      this.payJobFee(this.pay_jobId, this.monthRadio);
    },
    update(row) {
      localStorage.setItem("job", JSON.stringify(row));
      this.$router.push({
        path: "/addPlatformJob",
        query: {
          operate: "update"
        }
      });
    },
    async delConfirm(jobId) {
      let res = await this.$api.job.delPlatformJob(jobId);
      if (res.code === 0) {
        this.$message.success("删除成功！");
        this.getList();
      }
    },
    del(row) {
      this.$confirm("确认删除该职位?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.delConfirm(row.id);
      });
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    offline(jobId) {
      this.$confirm("确定下线该岗位？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$api.job.platformJobOffline(jobId).then(res => {
          if (res.code === 0) {
            this.$message.success("操作成功！");
            this.getList();
          }
        });
      });
    },
    toPay(jobId) {
      this.pay_jobId = jobId;
      this.dialogFormVisible = true;

      // this.$confirm("完成付费后，学生可以看到该岗位", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     this.payJobFee(jobId);
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消支付"
      //     });
      //   });
    },
    payJobFee(jobId, month) {
      let params = {
        subject: "平台岗位服务费",
        type: "web",
        // school_id: schoolId,
        // school_id: schoolId,
        job_id: jobId,
        fee_type: month
      };
      axios
        .post(
          baseUrl + "api/enterprise/pay/xcx_job/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[1].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[2].submit();
        });
    },
    publishStatus(row, column, cellValue, index) {
      let pay_status = row.pay_status;
      if (pay_status == "no_paid") {
        return "<span style='color:red'>待发布</span>";
      } else if (pay_status == "paid") {
        return "已发布";
      }
      //  else {
      //   return "-";
      // }
    },
    valid(jobId) {
      this.$confirm("确定上线该岗位？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$api.job
          .platformJobOnline(jobId, {
            status: "valid"
          })
          .then(res => {
            if (res.code === 0) {
              this.$message.success("操作成功！");
              this.getList();
            }
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
  .info {
    color: red;
    margin-left: 15px;
  }
}
.cell {
  .el-button {
    margin-left: 5px;
    margin-top: 3px;
  }
}
/deep/ .el-dialog{
  .el-dialog__body{
    padding: 5px 20px;
    .infoText{
      color: orange;
      margin-bottom: 20px;
    }
    .red{
      color: red;
      margin-top: 20px;
    }
  }
}
</style>
